import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import WhyNidan from "@/components/site/WhyNidan";
import HowItWorks from "@/components/site/HowItWorks";
import BeforeVisit from "@/components/site/BeforeVisit";
import AppointmentForm from "@/components/site/AppointmentForm";
import Testimonials from "@/components/site/Testimonials";
import Radiologist from "@/components/site/Radiologist";
import VisitUs from "@/components/site/VisitUs";
import Footer from "@/components/site/Footer";
import FloatingWhatsApp from "@/components/site/FloatingWhatsApp";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#f8fafc] text-slate-900">
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyNidan />
        <HowItWorks />
        <BeforeVisit />
        <AppointmentForm />
        <Testimonials />
        <Radiologist />
        <VisitUs />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
